export default function downloadFile(data: Blob | string, filename: string) {
  // Convert string to Blob if necessary
  const blobData = typeof data === 'string' ? new Blob([data]) : data;

  const aElement = document.createElement('a');
  aElement.setAttribute('download', filename);
  const href = URL.createObjectURL(blobData);
  aElement.href = href;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
}
